/**
 * Parent PartTypeIds used to filter metric limits by equipment area.
 * These IDs correspond to catPartTypes entries that act as parents in catPartTypesTree.
 *
 * The SP [RBD].[GetPartTypesMetricLimits] uses these to return the parent + its children.
 */

/** Roof (PartTypeId = 3) → children: Spider, 4th-Hole-Panel, 55-Degree, etc. */
export const ROOF_PARENT_PART_TYPE_IDS = "3";

/** Upper Shell (306) + Lower Shell (311) → children: Sidewall-Panel, Burner-Panel, Archway, Slag-Door, Sump, Burner components */
export const SIDEWALL_PARENT_PART_TYPE_IDS = "306,311";

/** Mold (1003) → children: Copper Mold Tube, Mold Body, Flanges, Collars, Seals, Foot Roll Assembly components */
export const CASTER_PARENT_PART_TYPE_IDS = "1003";
